import { Component } from 'solid-js'
import { rootModalStore } from '/web/store/root-modal'
import LoginPage from '../Login'
import HentaiLoginModal from '../Login/HentaiLoginModal'

const LoginModal: Component = () => {
  rootModalStore.addModal({
    id: 'login-modal',
    element: <LoginPage />,
  })

  rootModalStore.addModal({
    id: 'hentai-login-modal',
    element: <HentaiLoginModal />,
  })

  return null
}

export default LoginModal
